import axiosInstance from "./axiosInstance";

const ServiceService = {
    createService: async (serviceDTO) => {
        const response = await axiosInstance.post("/api/services", serviceDTO);
        return response.data;
    },
    updateService: async (id, serviceDTO) => {
        const response = await axiosInstance.put(`/api/services/${id}`, serviceDTO);
        return response.data;
    },
    deleteService: async (id) => {
        return await axiosInstance.delete(`/api/services/${id}`) // Soft delete returns 204
    },
    getService: async (id) => {
        const response = await axiosInstance.get(`/api/services/${id}`);
        return response.data;
    },
    getAllServices: async () => {
        const response = await axiosInstance.get("/api/services");
        return response.data;
    }
};

export default ServiceService;
